import React from 'react';
import { AcvtSupportedLanguages } from '../../../types/acvt';
import { useT } from '../../preview';
import style from './style.module.scss';

export const AcvtPlaceholderPage = (props: {
    /**
     * Kept for backward compatibility with existing call sites — the
     * component now reads its strings from the preview i18n context via
     * `useT()` and the prop is no longer consumed.
     */
    language?: AcvtSupportedLanguages;
    children: React.ReactNode;
}) => {
    const t = useT();
    return (
        <div className={style.placeholder_content}>
            {props.children}
            {t.common.emptyPlaceholder}
        </div>
    );
};
